<script setup lang="ts">
import { RouterView } from 'vue-router'
import Box from '@uiKit/elements/Box.vue'

// Full-screen guided-flow chrome: the wizard below it and nothing else. No
// sidebar — someone mid-flow has one job, and the nav rail only offers ways to
// abandon it. Auth is each route's own `requiresAuth`, not this shell's: the
// emailed owner-onboarding link mounts here too, signed out.
//
// The mounted route owns the whole viewport, chrome bar included: each wizard
// prints its own header, so this shell only pins the viewport and paints the base.
</script>

<template>
  <Box is="main" direction="col" class="wizard-shell" block>
    <RouterView />
  </Box>
</template>

<style scoped>
.wizard-shell {
  height: 100dvh;
  overflow: hidden;
  background: var(--p-surface-50);
}

@media (max-width: 992px) {
  .wizard-shell {
    height: auto;
    /* `dvh`, matching the desktop branch — `vh` overshoots the visible viewport
       while a mobile browser's URL bar is expanded and adds a dead scroll. */
    min-height: 100dvh;
    overflow: visible;
  }
}
</style>
